module.exports = __webpack_public_path__ + "img/operationTypes.6861387e.svg";